import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './Tooltip.scss'

/**
 * A "?" icon to be placed next to a label text to indicate that there's a tooltip
 * available. Wrapped in a special `<span>` to prevent the icon from being
 * wordwrapped onto an orphan line by itself.
 */
export function TooltipIcon() {
  return (
    <span className="ghg-tooltip-icon">
      &nbsp;
      <FontAwesomeIcon icon={faQuestionCircle} size="xs" transform={{ y: -4 }} />
    </span>
  )
}
